import { Component } from '@angular/core';
import { OrganisationService } from '@services/organisations/organisation.service';
import { DataTableEvent } from '../../components/data-table/data-table.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-user-admin',
    templateUrl: './user-admin.component.html',
    styleUrls: ['./user-admin.component.scss'],
    providers: [OrganisationService],
    standalone: false
})
export class UserAdminComponent {
  public columns = [{ prop: 'title' }];
  public params = {
    tag: { $ne: 'static' }
  }

  constructor(public organisationService: OrganisationService, private router: Router) {
  }

  public onDetail(event: DataTableEvent) {
    this.router.navigate(['user-admin', event.row.OrganisationID]);
  }
}
